import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import kz from './locales/kz.json';
import en from './locales/en.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ru,
            kz,
            en,
        },
        lng: 'kz',
        fallbackLng: 'kz',
        interpolation: {
            escapeValue: false,
        },
    });

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.querySelector('#root')
);
